/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext, useEffect } from "react";
import { DocumentEditContext } from "cms/documents/document-selector/context/document-edit-context";
import { formatBytes, getCleanFileType } from "utils/format-bytes";
import { Button } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { regular, solid } from "cms/icons";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import Config from "data/config";
import { isValidGuid } from "utils/empty-exists";
import { DocumentCard } from "../../dialog/document-cover";
import { DocumentArchiveDialog } from "../../dialog-archive";

// Extend dayjs timezone
dayjs.extend(timezone);

const { faBoxArchive } = regular;
const { faRepeat } = solid;
function formatDate (date) {
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const dateWithTimezone = dayjs.utc(date).tz(userTimeZone);
    return dateWithTimezone.format(Config.dates.display.datetime);
}

const DocumentDialogPreviewPanel = () => {

    const {
        openArchive,
        setOpenArchive,
        setIsReplacing,
        onDocumentArchived,
        setLocalState,
        selectedDocument,
        setIsArchiving
    } = useContext(DocumentEditContext);
    const hasDocument = isValidGuid(selectedDocument?.guid);

    const handleOpenReplace = () => {
        setIsReplacing(true);
    };

    const handleOpenArchive = () => {
        setIsArchiving(true);
    };

    useEffect(() => {
        setLocalState({
            document: selectedDocument,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedDocument]);

    return (
        <Fragment>

            {!hasDocument &&
                <div className="simplicity-doc-selector-window-preview-none">
                    No document selected
                </div>
            }

            {hasDocument &&
                <div className="simplicity-doc-selector-window-preview left-side doc-dialog-edit-resize">
                    <div className="simplicity-doc-selector-preview">
                        <div className='doc-details-cover doc-cover-left'>
                            <DocumentCard
                                displayWidth={232}
                                displayHeight={186}
                                fileExt={selectedDocument.file_ext}
                            />
                            <a
                                href={`${selectedDocument.url}?t=${Date.now()}`}
                                target='_blank'
                                className="view-doc-link"
                                rel='noopener noreferrer'
                            >
                                View document
                            </a>
                        </div>

                        <div className='doc-selector-properties doc-selector-properties-btns'>
                            {selectedDocument &&
                                <>
                                    <div>
                                        <span>Type:</span> {getCleanFileType(selectedDocument.file_type,selectedDocument.file_ext)}
                                    </div>
                                    <div>
                                        <span>Size:</span> {formatBytes(selectedDocument.file_size)}
                                    </div>
                                    <div className="doc-selector-button-container action-btns">
                                        <Button
                                            variant='outlined'
                                            color='secondary'
                                            onClick={handleOpenReplace}
                                            startIcon={
                                                <FontAwesomeIcon
                                                    icon={faRepeat}
                                                    style={{ color: "#0E7490" }}
                                                />
                                            }                                    
                                        >
                                            Replace
                                        </Button>
                                        <Button
                                            variant='outlined'
                                            color='secondary'
                                            onClick={handleOpenArchive}
                                            startIcon={
                                                <FontAwesomeIcon 
                                                    icon={faBoxArchive} 
                                                    style={{ color: "#0E7490" }}
                                                />
                                            }
                                        >
                                            Archive
                                        </Button>
                                    </div>
                                    <div><span>Uploaded:</span> {formatDate(selectedDocument.created_at)}</div>
                                    <div><span>Modified:</span> {formatDate(selectedDocument.updated_at)}</div>
                                </>
                            }
                        </div>

                    </div>
                </div>
            }

            <DocumentArchiveDialog
                selectedDocument={selectedDocument}
                open={openArchive}
                setOpen={setOpenArchive}
                onDocumentArchived={onDocumentArchived}
            />

        </Fragment>
    );
};

export { DocumentDialogPreviewPanel };
